import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { AwakeAuthTokenRequestForTest, AwakeAuthTokenResponseForTest } from "@maven-rest/sso/AuthToken.dto";
import { AuthTokenUrl } from "@maven-rest/sso/AuthToken.url";

export function useAwakeAuthTokenMutation(options?: SimpleMutationOptions<AwakeAuthTokenResponseForTest, AwakeAuthTokenRequestForTest>) {
  return useBaseMutation({
    fnOption: {
      host: process.env.REACT_APP_SSO_BE_URL,
      url: AuthTokenUrl.awakeAuthToken,
    },
    ...options,
  });
}
